export default __webpack_public_path__ + "static/media/threejs.0fd22e8f.png";